<template>
  <section>
    <div class="user">
      <div class="user-btns">
        <span>功能室信息</span>
        <el-button
          type="text" @click="handleControl(null, 'add')"
        >
          添加功能室
        </el-button
        >
      </div>
      <div class="user-table">
        <com-table :data="list" :configs="mineInfo.obj.table2" stripe border>
          <template v-slot:teacher_name="{ row }">
            <el-button type="text" @click="handleControl(row, 'user')">
              {{
                row.teacher_name ? row.teacher_name : "添加负责人"
              }}
            </el-button>
          </template>
          <template v-slot:operate="{ row }">
            <el-button
              type="text" @click="handleControl(row, 'edit')"
            >
              编辑
            </el-button
            >
            <span class="pad-row4">/</span>
            <el-button
              type="text" @click="handleControl(row, 'del')"
            >
              删除
            </el-button
            >
          </template>
        </com-table>
      </div>
    </div>
  </section>
</template>

<script>
import mock from '@/utils/mock'
import comTable from '@/components/comTable'
export default {
  name: 'ComUser',
  components: { comTable },
  props: {
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      mineInfo: mock.mine.set.viewInfo
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleControl(v, x) {
      this.$emit('control', v, x)
    }
  }
}
</script>

<style scoped lang="scss">
.user {
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  &-btns {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    > button {
      @include fun-btn(1);
    }
  }
  &-table {
    flex: 1;
    width: 100%;
  }
}
</style>
